export default "__VITE_ASSET__DnZUGHoA__"